import useFlag from '@/hooks/useFlag';
import { IFlagsmithFeature } from 'flagsmith/types';
import { Loader2 as Loader } from 'lucide-react';
import { ReactNode } from 'react';

type FeatureFlagProps = {
  flag: string;
  children: (flagState: IFlagsmithFeature) => ReactNode;
};

const FeatureFlag = ({ flag, children }: FeatureFlagProps) => {
  const { loading, error, flagValue } = useFlag(flag);

  if (loading) {
    return <Loader className="animate-spin" />;
  }

  if (error) {
    // no-dd-sa:typescript-best-practices/no-console
    // eslint-disable-next-line no-console
    console.error(error);
  }

  return children(flagValue);
};

export default FeatureFlag;
